module.exports = __webpack_public_path__ + "media/images/the-curve-logo-05abf0322231e277065f5ca1c033779c.webp";